import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { tasksSearch } from "../shell/task-search.ts";
import { loadTasks } from "../tasks/loaders.ts";
import { TasksPending } from "../tasks/pending.tsx";
import { TasksPage } from "../tasks/tasks-page.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null ? <NoAccessPage /> : <TasksPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/tasks/")({
  staticData: { hasPropertyContext: true },
  validateSearch: tasksSearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadTasks(context.data),
  pendingComponent: TasksPending,
  component: Page,
});
